var _circle, _circle2, _circle3, _circle4, _circle5, _ellipse, _ellipse2, _g, _g2, _g3, _g4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPredictionBall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 146,
    viewBox: "0 0 131 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 65.5,
    cy: 65.1,
    r: 65,
    fill: "#E1DEF8",
    fillOpacity: 0.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.5,
    cy: 65.1,
    r: 60,
    fill: "#E1DEF8",
    fillOpacity: 0.8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.5,
    cy: 62.1,
    r: 50,
    fill: "#E1DEF8",
    fillOpacity: 0.8
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 57.1,
    r: 45,
    fill: "#E1DEF8",
    fillOpacity: 0.8
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 57.1,
    r: 40,
    fill: "#E1DEF8",
    fillOpacity: 0.8
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 55.5,
    cy: 57.1,
    rx: 30,
    ry: 35,
    fill: "#E1DEF8",
    fillOpacity: 0.8
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.5,
    cy: 55.4333,
    rx: 20,
    ry: 23.3333,
    fill: "#E1DEF8",
    fillOpacity: 0.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_395_14888)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 55.1,
    r: 15,
    fill: "#E1DEF8",
    fillOpacity: 0.8
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_395_14888)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 55.1,
    r: 10,
    fill: "#E1DEF8",
    fillOpacity: 0.8
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_395_14888)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 54.6,
    r: 7.5,
    fill: "#E1DEF8",
    fillOpacity: 0.8
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_395_14888)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 55.1,
    r: 5,
    fill: "#E1DEF8",
    fillOpacity: 0.8
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122.565 73.2485L123.351 72.2492L122.351 73.0347L122 70.1L121.649 73.0347L120.649 72.2492L121.435 73.2485L118.5 73.6L121.435 73.9515L120.649 74.9508L121.649 74.1652L122 77.1L122.351 74.1652L123.351 74.9508L122.565 73.9515L125.5 73.6L122.565 73.2485Z",
    fill: "#827677"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9845 62.7987L85.6578 61.9422L84.8013 62.6155L84.5 60.1L84.1987 62.6155L83.3422 61.9422L84.0155 62.7987L81.5 63.1L84.0155 63.4012L83.3422 64.2578L84.1987 63.5845L84.5 66.1L84.8013 63.5845L85.6578 64.2578L84.9845 63.4012L87.5 63.1L84.9845 62.7987Z",
    fill: "#827677"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0653 99.2485L27.8508 98.2492L26.8515 99.0347L26.5 96.1L26.1485 99.0347L25.1492 98.2492L25.9347 99.2485L23 99.6L25.9347 99.9515L25.1492 100.951L26.1485 100.165L26.5 103.1L26.8515 100.165L27.8508 100.951L27.0653 99.9515L30 99.6L27.0653 99.2485Z",
    fill: "#827677"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0653 13.2485L64.8508 12.2492L63.8515 13.0347L63.5 10.1L63.1485 13.0347L62.1492 12.2492L62.9347 13.2485L60 13.6L62.9347 13.9515L62.1492 14.9508L63.1485 14.1652L63.5 17.1L63.8515 14.1652L64.8508 14.9508L64.0653 13.9515L67 13.6L64.0653 13.2485Z",
    fill: "#827677"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0653 31.2485L92.8508 30.2492L91.8515 31.0347L91.5 28.1L91.1485 31.0347L90.1492 30.2492L90.9347 31.2485L88 31.6L90.9347 31.9515L90.1492 32.9508L91.1485 32.1652L91.5 35.1L91.8515 32.1652L92.8508 32.9508L92.0653 31.9515L95 31.6L92.0653 31.2485Z",
    fill: "#827677"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5653 31.2485L30.3508 30.2492L29.3515 31.0347L29 28.1L28.6485 31.0347L27.6492 30.2492L28.4347 31.2485L25.5 31.6L28.4347 31.9515L27.6492 32.9508L28.6485 32.1652L29 35.1L29.3515 32.1652L30.3508 32.9508L29.5653 31.9515L32.5 31.6L29.5653 31.2485Z",
    fill: "#827677"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4038 64.3489L16.9648 63.6351L16.2511 64.1962L16 62.1L15.7489 64.1962L15.0352 63.6351L15.5962 64.3489L13.5 64.6L15.5962 64.851L15.0352 65.5648L15.7489 65.0037L16 67.1L16.2511 65.0037L16.9648 65.5648L16.4038 64.851L18.5 64.6L16.4038 64.3489Z",
    fill: "#827677"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5653 106.248L89.3508 105.249L88.3515 106.035L88 103.1L87.6485 106.035L86.6492 105.249L87.4347 106.248L84.5 106.6L87.4347 106.951L86.6492 107.951L87.6485 107.165L88 110.1L88.3515 107.165L89.3508 107.951L88.5653 106.951L91.5 106.6L88.5653 106.248Z",
    fill: "#827677"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7268 92.1481L52.7367 90.8632L51.4519 91.8732L51 88.1L50.5481 91.8732L49.2633 90.8632L50.2732 92.1481L46.5 92.6L50.2732 93.0519L49.2633 94.3367L50.5481 93.3267L51 97.1L51.4519 93.3267L52.7367 94.3367L51.7268 93.0519L55.5 92.6L51.7268 92.1481Z",
    fill: "#827677"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5 143.6C86.5 146.085 76.8741 145.1 65 145.1C53.1259 145.1 43.5 146.085 43.5 143.6C43.5 141.115 53.1259 139.1 65 139.1C76.8741 139.1 86.5 141.115 86.5 143.6Z",
    fill: "url(#paint0_linear_395_14888)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M100.5 122.554C100.5 127.524 84.2777 141.054 65.5 141.054C46.7223 141.054 30.5 127.524 30.5 122.554C30.5 117.583 46.7223 130.054 65.5 130.054C84.2777 130.054 100.5 117.583 100.5 122.554Z",
    fill: "#9B7BD0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_395_14888",
    x: 29.5,
    y: 36.1,
    width: 38,
    height: 38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_395_14888"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_395_14888",
    x: 36.5,
    y: 41.1,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_395_14888"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_395_14888",
    x: 38.5,
    y: 43.1,
    width: 23,
    height: 23,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_395_14888"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_395_14888",
    x: 41.5,
    y: 46.1,
    width: 18,
    height: 18,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_395_14888"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_395_14888",
    x1: 40.705,
    y1: 147.15,
    x2: 50.4772,
    y2: 123.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPredictionBall);
export default __webpack_public_path__ + "static/media/prediction-ball.015e9c93d74cef5683789ca2e5ec39ba.svg";
export { ForwardRef as ReactComponent };